import React from 'react';
import { makeStyles } from '@mui/styles';
import { Tab, Tabs } from '@mui/material';

import Receipts from './Receipts/Receipts';
import UsedCredits from './Credits/UsedCredits';
import SavedCards from './SavedCards/SavedCards';
import AccountBalance from './Credits/AccountBalance';
import RemainingCredits from './Credits/RemainingCredits';
import ExpiredCredits from './Credits/ExpiredCredits';
import { TabPanel, a11yProps } from '../../../../../../common/utils/TabPanel';
import {
  CONSUMER_PROFILE_TABS,
  useCustomerProfileQueryParams
} from '../../useCustomerProfileQueryParams';

const useStyles: any = makeStyles((theme: any) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    backgroundColor: theme.palette.background.paper
  },
  tabs: {
    width: '240px',
    minWidth: '200px',
    justifyContent: 'flex-start',
    borderRight: `1px solid ${theme.palette.divider}`
  },
  tLeft: {
    '& .MuiTab-wrapper': {
      justifyContent: 'flex-start'
    }
  },
  contentPanel: {
    padding: 8
  }
}));

function AccountTabs(props: any) {
  const classes = useStyles();
  const { customerAllData } = props;
  const [{ subTab }, setQuery] = useCustomerProfileQueryParams();

  const subTabs = CONSUMER_PROFILE_TABS['account'];
  const currentIndex = Math.max(
    subTabs.findIndex(t => t === subTab),
    0
  );

  const handleChange = (_: unknown, newIndex: number) => {
    setQuery({ tab: 'account', subTab: subTabs[newIndex] });
  };

  return (
    <div className={classes.root}>
      <Tabs
        value={currentIndex}
        centered={true}
        textColor="primary"
        scrollButtons="auto"
        orientation="vertical"
        onChange={handleChange}
        indicatorColor="primary"
        className={classes.tabs}
      >
        <Tab
          {...a11yProps(0)}
          label="All Saved Cards"
          className={classes.tLeft}
        />
        <Tab
          {...a11yProps(1)}
          label="Receipt History"
          className={classes.tLeft}
        />
        <Tab {...a11yProps(2)} label="Used Credits" className={classes.tLeft} />
        <Tab
          {...a11yProps(3)}
          label="Remaining Credits"
          className={classes.tLeft}
        />
        <Tab
          {...a11yProps(4)}
          label="Expired Credits"
          className={classes.tLeft}
        />
        <Tab
          {...a11yProps(5)}
          label="Account Balance"
          className={classes.tLeft}
        />
      </Tabs>
      <div style={{ width: '100%' }}>
        <TabPanel value={currentIndex} index={0}>
          <SavedCards customerAllData={customerAllData} />
        </TabPanel>
        <TabPanel value={currentIndex} index={1}>
          <Receipts customerAllData={customerAllData} />
        </TabPanel>
        <TabPanel value={currentIndex} index={2}>
          <UsedCredits customerAllData={customerAllData} />
        </TabPanel>
        <TabPanel value={currentIndex} index={3}>
          <RemainingCredits customerAllData={customerAllData} />
        </TabPanel>
        <TabPanel value={currentIndex} index={4}>
          <ExpiredCredits customerAllData={customerAllData} />
        </TabPanel>
        <TabPanel value={currentIndex} index={5}>
          <AccountBalance customerAllData={customerAllData} />
        </TabPanel>
      </div>
    </div>
  );
}

export default AccountTabs;
